import * as moment from 'moment';

const formatDayDifference = dayDifference => ((dayDifference > 0) ? `+${dayDifference}` : dayDifference);
const getAbsoluteMinutesFromMillis = (millis: number): number => Math.floor(millis / 60000);

export const calculateDayDifferenceBetweenMillis = (fromMillis: number, toMillis: number) => {
  const fromTime = getMomentFromMillis(fromMillis).startOf('day');
  const toTime = getMomentFromMillis(toMillis).startOf('day');

  return fromTime.diff(toTime, 'days');
};

export const formatMillis = (millis: number, format: string): string => {
  return getMomentFromMillis(millis).format(format);
};

export const getCombinedTimestampFromDateAndTime = (dateDate: number, timeDate: number): number => {
  const time = getMomentFromMillis(timeDate);
  const date = getMomentFromMillis(dateDate);
  const combinedDate = moment({
    year: date.year(),
    month: date.month(),
    day: date.date(),
    hour: time.hours(),
    minute: time.minutes()
  });

  return combinedDate.valueOf();
};

export const getCurrentMillis = () => moment().valueOf();

export const getDayDifference  = (date, referenceDate) => {
  const dayDifference = calculateDayDifferenceBetweenMillis(date, referenceDate);

  return (!dayDifference) ? '' : formatDayDifference(dayDifference);
};

export const getFirstOfDate = (date: number) => moment(date).startOf('date').valueOf();

export const getFirstOfToday = () => moment().startOf('date').valueOf();

export const getHoursFromMillis = (millis: number) => {
  return Math.floor(getAbsoluteMinutesFromMillis(millis) / 60);
};

export const getLastOfDate = (date: number) => moment(date).endOf('date').valueOf();

export const getLastOfToday = () => moment().endOf('date').valueOf();

export const getMillisFromDateLikeString = (date: string) => moment(new Date(date)).valueOf();

export const getMillisFromStringWithFormat = (value: string, format: string): number => {
  return moment(value, format).valueOf();
};

export const getMinutesFromMillis = (millis) => {
  return Math.floor(getAbsoluteMinutesFromMillis(millis) % 60);
};

export const getMomentFromDayMonthAndYear = (day: number, month: number, year: number): moment.Moment => {
  return moment({
    date: day,
    month: month - 1,
    year: year
  });
};

export const getMomentFromMillis = (millis: number): moment.Moment => {
  return moment(millis);
};
export const getTimeInDate = (startTime: number, endTime: number, date: number) => {
  const firstOfDate = getMomentFromMillis(date).startOf('date').valueOf();
  const lastOfDate = getMomentFromMillis(date).endOf('date').valueOf();

  const from = (startTime < firstOfDate) ? firstOfDate : startTime;
  const to = (endTime > lastOfDate) ? lastOfDate : endTime;

  return to - from;
};

export const initDaterangepickerDates = () => {
  const start = moment().startOf('month').valueOf();
  const end = moment().endOf('date').valueOf();

  return { start, end };
};



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/utils/date.utils.ts